module.exports = __webpack_public_path__ + "static/media/aftanverdlaeri.26f9f69f.png";